import { createContext as e, useContext as t } from "react";
import { jsx as n } from "react/jsx-runtime";
//#region src/OAuthConfigContext.tsx
var r = e({}), i = ({ config: e, children: t }) => /* @__PURE__ */ n(r.Provider, {
	value: e ?? {},
	children: t
}), a = () => t(r);
//#endregion
export { i as OAuthConfigProvider, a as useOAuthConfig };
